module.exports = new __parcel__URL__("load_text_3.257636cd.png").toString();